import { PaymentMethod } from '@iheartjane/data-access';
import { useEffect } from 'react';

import { useCheckoutPayments } from '../../CheckoutPayments/CheckoutPaymentsProvider';
import { useSubmitCheckout } from './useSubmitCheckout';

// This is essentially a payments spy. When certain tokens/authorizations are captured,
// we automatically submit the checkout.
export const useAutoSubmitCheckout = () => {
  const { selected, canPayIntent, monerisTicket } = useCheckoutPayments();
  const { submit } = useSubmitCheckout();

  const autoSubmit =
    (selected === PaymentMethod.canpay && !!canPayIntent) ||
    (selected === PaymentMethod.moneris && !!monerisTicket);

  useEffect(() => {
    if (autoSubmit) {
      submit();
    }
  }, [canPayIntent, monerisTicket]);
};
